import dayjs from 'dayjs';

const plausibleEmailRegex = /^[^\s@|]+@[^\s@|]+\.[^\s@|]+$/;

// The token is base64('email|hash|YYYY-MM-DD HH:mm:ss'); null when truncated or mangled.
export const parsePasswordResetToken = (encodedToken: string) => {
  let decoded: string;

  try {
    decoded = window.atob(encodedToken);
  } catch {
    return null;
  }

  const [emailAddress, token, rawExpiredAt, ...rest] = decoded.split('|');

  if (rest.length > 0 || !token || !plausibleEmailRegex.test(emailAddress)) return null;

  const expiredAt = dayjs(rawExpiredAt);

  if (!expiredAt.isValid()) return null;

  return { emailAddress, expiredAt, token };
};
